export default __webpack_public_path__ + "static/media/expand_white.837ae533.svg";